import React from 'react';
import PropTypes from 'prop-types';
import './PageTitle.scss';

const PageTitle = props => (
  <div className="page-title">
    <h3 className="page-title__text">{props.title}</h3>
  </div>
);

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PageTitle;
